import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';
import { AuthedLayout } from '@/components/layout/AuthedLayout';
import { isJwtExpired } from '@/lib/auth/jwt';
import { refreshSessionFromCookie } from '@/lib/auth/session';
import { buildRedirectTarget } from '@/lib/router/navigation';
import { useAuthStore } from '@/stores/auth';

function AuthedLayoutRoute() {
  return (
    <AuthedLayout>
      <Outlet />
    </AuthedLayout>
  );
}

export const Route = createFileRoute('/_authed')({
  beforeLoad: async ({ location }) => {
    const accessToken = useAuthStore.getState().accessToken;

    if (accessToken && !isJwtExpired(accessToken)) {
      return;
    }

    const refreshedToken = await refreshSessionFromCookie();
    if (refreshedToken && !isJwtExpired(refreshedToken)) {
      return;
    }

    throw redirect({
      to: '/login',
      search: { redirect: buildRedirectTarget(location) },
      replace: true,
    });
  },
  component: AuthedLayoutRoute,
});
